<template>
  <v-container fluid class="investfund-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-investfund`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-finance</v-icon>
            Fund
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>

          <v-tab-item
            :value="'tab-investfund'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Fund</p>
                      <v-text-field
                        class="mb-4"
                        type="Number"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'fundrank')"
                        v-bind:value="initvalue.fundrank"
                        placeholder="Fund Rank"
                        persistent-hint
                        single-line hint="Enter the fund rank">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'fundcode')"
                        v-bind:value="initvalue.fundcode"
                        placeholder="Fund Code"
                        persistent-hint
                        single-line hint="Enter the fund code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'fundname')"
                        v-bind:value="initvalue.fundname"
                        placeholder="Fund Name"
                        persistent-hint
                        single-line hint="Enter the fund name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=fund_types
                        :value="initvalue.fundtype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'fundtype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the fund type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'fundstatus')"
                          v-bind:label="initvalue.fundstatus"
                          v-model="initvalue.fundstatus"
                          value="Active"
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="accounts.filter(x=>x.accountsubclass=='Other Asset').map(x => {return {text: x.accountname, value: x._id};})"
                        :value="initvalue.asset_accountid"
                        v-on:change="updateChangedValue($event, 'asset_accountid')"
                        outlined
                        dense
                        placeholder="Asset Account"
                        persistent-hint
                        single-line hint="Please choose the asset account">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="accounts.filter(x=>x.accountsubclass=='Other Asset').map(x => {return {text: x.accountname, value: x._id};})"
                        :value="initvalue.cash_accountid"
                        v-on:change="updateChangedValue($event, 'cash_accountid')"
                        outlined
                        dense
                        placeholder="Cash Account"
                        persistent-hint
                        single-line hint="Please choose the cash account">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="accounts.filter(x=>x.accountsubclass=='Bank').map(x => {return {text: x.accountname, value: x._id};})"
                        :value="initvalue.bank_accountid"
                        v-on:change="updateChangedValue($event, 'bank_accountid')"
                        outlined
                        dense
                        placeholder="Bank Account"
                        persistent-hint
                        single-line hint="Please choose the bank account">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="accounts.filter(x=>x.accountsubclass=='Other Income').map(x => {return {text: x.accountname, value: x._id};})"
                        :value="initvalue.dividend_accountid"
                        v-on:change="updateChangedValue($event, 'dividend_accountid')"
                        outlined
                        dense
                        placeholder="Dividend Account"
                        persistent-hint
                        single-line hint="Please choose the dividend account">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="accounts.filter(x=>x.accountsubclass=='Other Income').map(x => {return {text: x.accountname, value: x._id};})"
                        :value="initvalue.interest_accountid"
                        v-on:change="updateChangedValue($event, 'interest_accountid')"
                        outlined
                        dense
                        placeholder="Interest Account"
                        persistent-hint
                        single-line hint="Please choose the interest account">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="accounts.filter(x=>x.accountclass=='Expense').map(x => {return {text: x.accountname, value: x._id};})"
                        :value="initvalue.expense_accountid"
                        v-on:change="updateChangedValue($event, 'expense_accountid')"
                        outlined
                        dense
                        placeholder="Expense Account"
                        persistent-hint
                        single-line hint="Please choose the expense account">
                      </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                          to="/investfund/list"
                          replace
                          outlined
                          color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                        <v-btn
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="editInvestFund()">
                          Save
                        </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onImageFile" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/investfund/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import router from '@/Routes';
import {mapActions, mapState} from "vuex";

export default {
  data () {
    return {
      filename: null,
      imageurl: undefined,
      errorindex: undefined,
      change_fund: {},
      upload_photo: {},
      initvalue: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      fund_types: ['Stocks', 'Bonds'],
    }
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('InvestFund', ['isReceiving']),
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('InvestFund', ['getInvestFundRequest', 'updateInvestFundRequest','updateInvestFundImageRequest', 'updateInvestFundUnitRequest']),
    async editInvestFund() {
      this.change_fund._id = this.initvalue._id;
      await this.updateInvestFundRequest(this.change_fund);
      router.push('/investfund/list');
    },
    async editPhoto() {
      this.upload_photo._id = this.initvalue._id;
      await this.updateInvestFundImageRequest(this.upload_photo);
      router.push('/investfund/list');
    },
    updateChangedValue(value, field){
      this.change_fund[field] = value;
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => this.imageurl = e.target.result;
      reader.readAsDataURL(file);
    },
    onImageFile(file) {
      if (!file) {return;}
      this.upload_photo.fundimage = file;
      this.upload_photo.imagename = file.name;
      this.createImage(file);
    },
  },

  async created () {
    this.initvalue = this.$route.params;
    this.imageurl = this.initvalue.fundimage;
    if(!this.initvalue._id) this.$router.push({ name: 'InvestFundList' });
    if(this.accounts.length==0) await this.getAccountsRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
